module.exports = __webpack_public_path__ + "img/credential6.c4f45313.png";